import updateForm from "../product-template/update";
import getFormData from "../utils/getFormData";
import getVariant from "../utils/getVariant";

const productForm = () => {
  const $productTemplates = document.querySelectorAll(
    "[theme-product-template]"
  );

  if ($productTemplates.length === 0) {
    return;
  }

  $productTemplates.forEach(($el) => {
    const $productTemplate = $el as HTMLElement;
    if ($productTemplate.dataset.initialized === "true") return;
    $productTemplate.dataset.initialized = "true";

    const { product } = $productTemplate.dataset;
    if (!product) return;
    const productData = JSON.parse(product);
    const $form = $productTemplate.querySelector(
      ".product-options-form form"
    ) as HTMLFormElement;

    if (!$form) {
      return;
    }

    $form.addEventListener("change", () => {
      const options: { [key: string]: string } = {
        option1: "",
        option2: "",
        option3: "",
      };
      const extraOptions: { [key: string]: string } = {};
      const formData = getFormData($form);
      formData.forEach((item) => {
        const [key, value] = item;
        const stringValue = value as string;
        if (key.includes("option")) {
          options[key] = stringValue;
        } else {
          extraOptions[key] = stringValue;
        }
      });
      const selectedVariant = getVariant(productData, options);
      if (selectedVariant) {
        updateForm(selectedVariant, extraOptions, $productTemplate);
      } else {
        console.error("Variant not found", options);
      }
    });
  });
};

export { productForm };
